import { Button, Loader, Text } from "@marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { MdOutlineTextSnippet } from "react-icons/md";

interface ProductActionsProps {
  onPublish: () => void;
  onDiscard?: () => void;
  onSaveDraft: () => void;
  isPending: boolean;
  isSavingDraft: boolean;
  isEditingPublishedProduct?: boolean;
}

export const ProductActions: React.FC<ProductActionsProps> = ({
  onPublish,
  onDiscard,
  onSaveDraft,
  isPending,
  isSavingDraft,
  isEditingPublishedProduct = false
}) => {
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation("common");
  const { t: tProduct } = useTranslation("product");

  const handleDiscard = () => {
    if (onDiscard) {
      onDiscard();
    } else {
      navigate({ to: "/products/list" });
    }
  };

  return (
    <div className="space-y-6 w-[226px] sticky top-1 h-fit">
      <div className="bg-brand-white rounded-lg border border-solid border-mischka-400 p-6">
        <Text size="s" className="text-fjord-grey-300 mb-[14px] text-center">
          {tProduct("addProductPage.readyToPublish")}
        </Text>

        <Button
          type="submit"
          variant="primary"
          onClick={onPublish}
          loading={isPending}
          fullWidth
          className="mb-2"
        >
          {tCommon("publish")}
        </Button>

        <Button
          variant="secondary"
          onClick={handleDiscard}
          disabled={isPending || isSavingDraft}
          fullWidth
        >
          {tCommon("discard")}
        </Button>

        {!isEditingPublishedProduct && (
          <>
            <hr className="my-[14px] h-px border-0 bg-mischka-100" />

            <Button
              variant="secondary"
              className="w-full"
              onClick={onSaveDraft}
              disabled={isSavingDraft || isPending}
              rightSection={
                isSavingDraft ? (
                  <Loader size="xs" />
                ) : (
                  <MdOutlineTextSnippet size={18} />
                )
              }
            >
              {tProduct("actions.saveAsDraft")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
